<div class="row">
  <div class="col-xs-12">
    <h4>{{ 'TORRES_CREDENTIALS.TITLE'|translate }}</h4>
    <p>{{ 'TORRES_CREDENTIALS.DESCRIPTION'|translate }}</p>
  </div>
</div>

<ng-container *ngIf="!loading; else loadingSpinner">
  <div class="row">
    <div class="col-sm-6">
      <form #credentialsForm="ngForm" (ngSubmit)="save(credentialsForm)" id="torres-credentials-form">
        <!-- API Key -->
        <div class="form-group">
          <label class="control-label" for="torres-api-key">
            {{ 'TORRES_CREDENTIALS.API_KEY'|translate }}
          </label>
          <div class="input-group">
            <input
              [type]="showApiKey ? 'text' : 'password'"
              id="torres-api-key"
              name="apiKey"
              class="form-control"
              [(ngModel)]="credentials.apiKey"
              [disabled]="processing"
              required
              maxlength="128"
              autocomplete="new-password">
            <span class="input-group-btn">
              <button type="button" class="btn btn-default" (click)="toggleApiKeyVisibility()" [disabled]="processing">
                <span class="material-symbols-rounded">{{ showApiKey ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </span>
          </div>
        </div>

        <!-- Intermediary -->
        <div class="form-group" hasError>
          <label class="control-label">{{ 'TORRES_CREDENTIALS.INTERMEDIARY'|translate }}</label>
          <selectize *ngIf="!credentials.intermediary"
            required
            [maxItems]="1"
            [searchURL]="companyService.getCompanies(companyId, { all: true })"
            [searchField]="['name', 'fiscal_id.value']"
            [(ngModel)]="credentials.intermediary"
            name="intermediary"
            [disabled]="processing"
            placeholder="{{ 'TORRES_CREDENTIALS.SEARCH_INTERMEDIARY_PLACEHOLDER'|translate }}">
          </selectize>
          <error-list></error-list>
          <div *ngIf="credentials.intermediary" class="editable-pill">
            <button [disabled]="processing" type="button" class="close" (click)="credentials.intermediary = undefined">
              <span aria-hidden="true">&times;</span>
            </button>
            <company-info [company]="credentials.intermediary"></company-info>
          </div>
        </div>

        <!-- Success message -->
        <div class="alert alert-success" *ngIf="saved">
          {{ 'TORRES_CREDENTIALS.SAVED'|translate }}
        </div>

        <!-- Error message -->
        <div class="alert alert-danger" *ngIf="error">
          {{ 'TORRES_CREDENTIALS.ERROR'|translate }}
        </div>

        <button
          type="submit"
          form="torres-credentials-form"
          class="btn btn-agree"
          [disabled]="!credentialsForm.valid || processing">
          {{ 'TORRES_CREDENTIALS.SAVE'|translate }}
        </button>
      </form>
    </div>
  </div>
</ng-container>

<ng-template #loadingSpinner>
  <div class="loading">
    <spinner message="{{ 'GLOBAL.LOADING'|translate }}"></spinner>
  </div>
</ng-template>
